export default __webpack_public_path__ + "static/media/Group923.d2255143.svg";